//
//
//
//
//
//
//
//
//
//
//

	export default {
		props: ['proge'],
		data () {
			return{

			}
		},
		methods: {
			progess () {
				console.log(this.proge)
				if(this.proge>=100){
					this.$refs.progessWidth.style.right = '0px';
					this.$refs.propsWidth.style.width = '100%';
				}else if (this.proge<10){
					this.$refs.progessWidth.style.left = (this.proge-2)+'%';
					this.$refs.propsWidth.style.width = this.proge+'%';
				}else{
					this.$refs.progessWidth.style.left = (this.proge-2)+'%';
					this.$refs.propsWidth.style.width = this.proge+'%';
				}
			}
		},
		watch:{
			proge() {
				if(this.proge>=100){
					this.$refs.progessWidth.style.right = '0px';
					this.$refs.propsWidth.style.width = '100%';
				}else if (this.proge<10){
					this.$refs.progessWidth.style.left = (this.proge-2)+'%';
					this.$refs.propsWidth.style.width = this.proge+'%';
				}else{
					this.$refs.progessWidth.style.left = (this.proge-2)+'%';
					this.$refs.propsWidth.style.width = this.proge+'%';
				}
			}
		},
		mounted (){
			this.progess()
		}
	}



// WEBPACK FOOTER //
// ./src/crowd_fund/Progress.vue